export const CABLE_FLAG = 'CABLE_FLAG';
export const PATCH_PANEL = 'PATCH_PANEL';